import type { CountrySchema } from '@tectonics/prs/country/schema/types';
import { getSafeUi, isLocalPayment } from '@tectonics/prs/incoming-payment';
import { ALL_STATUSES, OP } from '@tectonics/prs/incoming-payment/payment-status';
import { shouldDisabledCustomerNameField } from '@tectonics/prs/ui/get-disabled-customer-name-field';
import { shouldIgnorePhoneNumber } from '@tectonics/prs/ui';

export const zambiaCountrySchema: CountrySchema = {
  country: 'zm',
  display: [
    { type: 'display', id: 'merchant_logo', statuses: ALL_STATUSES },
    { type: 'display', id: 'receipt_original_amount', statuses: ALL_STATUSES },
    {
      type: 'display',
      id: 'receipt_fx_rate',
      statuses: ALL_STATUSES,
      condition: ({ incomingPayment }) => !isLocalPayment(incomingPayment),
    },
    { type: 'display', id: 'receipt_final_amount', statuses: ALL_STATUSES },
    { type: 'display', id: 'back_button', statuses: OP },
  ],
  fields: [
    {
      type: 'field',
      component: 'input',
      id: 'name',
      input_type: 'text',
      validation: 'name',
      statuses: OP,
      disabled: ({ incomingPayment }) => shouldDisabledCustomerNameField(incomingPayment),
    },
    { type: 'field', component: 'input', id: 'email', input_type: 'email', validation: 'email', statuses: OP },
    {
      type: 'field',
      component: 'input',
      id: 'phone_number',
      input_type: 'tel',
      validation: 'phone_number',
      statuses: OP,
      optional_field_name: 'telephone',
      condition: ({ incomingPayment }) => (
        incomingPayment.status === 'OP'
        && !shouldIgnorePhoneNumber(getSafeUi(incomingPayment))
      ),
    },
  ],
  paymentMethods: {
    ewallet: {
      display: [
        { type: 'display', id: 'ewallet_accepts_brand', traits: ['airtel'], statuses: OP },
      ],
    },
  },
};
